import Vue from 'vue';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

Vue.component('v-select', VSelect);
